// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2m0Bt","content":"RecentSearches_content__4tPaT"};